import domReady from '@wordpress/dom-ready';
import manifest from './../manifest.json';

domReady(async () => {
	const timelineContentSelector = `.${manifest.blockJsClass}`;
	const timelineContentItems = document.querySelectorAll(`.${manifest.blockJsClass}`);

	if (!timelineContentItems?.length) {
		return;
	}

	const { TimelineContentToggle } = await import('./timeline-content-toggle');

	timelineContentItems.forEach((item) => {
		new TimelineContentToggle({
			timelineContent: item,
			timelineContentSelector: timelineContentSelector,
		}).init();
	});
});
